var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",class:[_vm.b(),_vm.className],style:(_vm.styleSizeName),on:{"click":_vm.handleClick}},[_c('iframe',{style:(_vm.styleChartName),attrs:{"src":_vm.dataChart.value,"draggable":"false"}})])}
var staticRenderFns = []

export { render, staticRenderFns }